module.exports = __webpack_public_path__ + "static/media/High gain (Modded Mark II C) VR.bd1e1ed.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/High gain (Modded Mark II C) VR.mp3
// module id = VrU4
// module chunks = 12